import DashboardAssignmentGrid from '../dashboard-assignment-grid/DashboardAssignmentGrid';
import {
  useAssignmentGridData,
  useDrawAssignmentFromPool,
} from '../../../hooks/dashboard/useDashboard';
import Box from '@mui/material/Box';
import './ReviewerDashboard.scss';

const ReviewerDashboard = () => {
  const {data, isLoading, refetch} = useAssignmentGridData();
  const {mutate: drawAssignment} = useDrawAssignmentFromPool();

  return (
    <Box className="review-dashboard">
      <DashboardAssignmentGrid
        loading={isLoading}
        assignments={data?.reviewerAssignments}
        className={
          data?.reviewerAssignments?.length > 0 ? '' : 'arr-datagrid-no-data'
        }
        onDrawClick={(assignmentID: number) => {
          drawAssignment(assignmentID, {
            onSuccess: () => refetch(),
          });
        }}
      />
    </Box>
  );
};

export default ReviewerDashboard;
